// extracted by mini-css-extract-plugin
export default {"Header__content":"lT2DCGilrX5qVFD1tetS"};